/**
 * Phase 36.4 hardening — shared QueryClient singleton.
 *
 * Extracted from `main.tsx` so the auth store can call `clear()` on
 * logout. Without this, React Query's cache survives a logout/login
 * pair and a fast re-auth within `staleTime` (30s) serves cached
 * org-scoped data (e.g. `useSubscription`'s `['billing','subscription']`
 * key) to the next merchant who logs in on the same browser.
 *
 * Re-exported by `main.tsx` for the QueryClientProvider; consumed by
 * `authStore.logout()` for the cache-clear-on-sign-out side-effect.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});
